<template>
  <div>
    <section>
      <h2>Monday -- Math, 10am</h2>
      <p>We will do Math again: Please make sure your child has a pencil and some paper to write on.</p>
      <a href="https://sandiegounified.zoom.us/j/96422746818">Zoom Meeting:</a>
      Meeting ID: 964 2274 6818
      Password: 912543
      <br />
      <br />
      <hr />
    </section>
    <section>
      <h2>Tuesday -- Reading Time, 10am</h2>
      <h3>with Miss Emeline:</h3>
      <p>Groupe C: 10h - 10h30 Clark, Logan, Camila, Madisyn, Grayson, Maxton</p>
      <a
        href="https://us04web.zoom.us/j/7892815880?pwd=dGJrc2hLMFZFRnZMUGNWQzVWMEFiQT09"
      >Zoom meeting:</a>
      Meeting ID : 789 281 5880
      password : anduze
      <br />
      <br />
      <hr />
    </section>
    <section>
      <h2>Thursday -- Reading Time, 10am</h2>
      <h3>With Mme Andrews:</h3>
      <p>10:00 am: Group C: Clark, Logan, Camila, Madisyn, Grayson, Maxton</p>
      <a href="https://sandiegounified.zoom.us/j/92850175210">Zoom meeting</a>
      Meeting ID: 928 5017 5210
      Password: 157609
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>